import React from "react";
import styles from "./footer.module.css";
import { Link } from "react-router-dom";
import { FaFacebook } from "react-icons/fa6";
import { BsTwitterX } from "react-icons/bs";
import { FaInstagram } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { MdPrivacyTip } from "react-icons/md";

const Footer = ({ isLoggedIn }) => {
  /* The website footer is used on most pages of the website. It contains information about the website, and links to social media, privacy policy, and contact page. */

  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.sections}>
        <div className={styles.contactUs}>
          <h2>Contact us</h2>
          <ul>
            <li>Speaker Ltd</li>
            <li>service@socialspeaker.com</li>
            <li>
              <address>3398 County Line Road</address>
            </li>
            <li>
              <address className={styles.addressUppercase}>
                Tampa FL 33614
              </address>
            </li>
            <li>
              <address className={styles.addressUppercase}>USA</address>
            </li>
          </ul>
        </div>

        {/* Guidelines section */}
        <div className={styles.aboutUs}>
          <h2>More about us</h2>
          <p>
            Speaker represents a modern and enjoyable way of learning. It
            combines an active social network, with advanced language learning
            tools. Join now for free, and take a major step forward in your
            journey of acquiring a new language.
          </p>
        </div>

        {/* Social Links section */}

        <div className={styles.socialLinks}>
          <div className={styles.generalPages}>
            <div className={styles.signBlock}>
              <MdEmail className={styles.sign} />
              <p>
                {isLoggedIn && <Link to="/acontact">Get in Touch</Link>}
                {!isLoggedIn && <Link to="/contact">Get in Touch</Link>}
              </p>
            </div>

            <div className={styles.signBlock}>
              <MdPrivacyTip className={styles.sign} />
              <p>
                {isLoggedIn && <Link to="/aprivacy">Privacy Policy</Link>}
                {!isLoggedIn && <Link to="/privacy">Privacy Policy</Link>}
              </p>
            </div>
          </div>

          <div className={styles.socialIcons}>
            <span>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook />
              </a>
            </span>
            <span>
              <a
                href="https://x.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsTwitterX />
              </a>
            </span>
            <span>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
            </span>
          </div>
        </div>
      </div>
      <p className={styles.bottomp}>
        Speaker {year} All rights reserved &copy;
      </p>
    </footer>
  );
};

export default Footer;
